import { all } from 'redux-saga/effects';
import cashbackSaga from 'src/store/cashback/saga';
import client from '../../../store/client/sagas';
import globalView from '../../../store/view/sagas';
import globalAnalytics from '../../../store/analytics/sagas';
import wishlist from '../../../store/wishlist/sagas';
import mindboxAnalytics from '../../../store/mindbox/sagas';

function* sagas() {
  const availableWithSsrSagas = [
    wishlist(),
    client(),
    globalView(),
    globalAnalytics(),
    mindboxAnalytics(),
    cashbackSaga(),
  ];

  yield all(availableWithSsrSagas);
}

export default sagas;
